import { Actions } from '@ngrx/effects';
import { Injectable } from '@angular/core';

@Injectable()
export class CoreEffects {
  constructor(private actions$: Actions) {}
}